import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Env } from '../../../env/env';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private baseUrl : string = `${Env.baseUrl}`;
    
    constructor(
     private http: HttpClient,
     private _Router: Router,
     private storageService: StorageService
   ) { }
   

  public login(data: any) : Observable<any> {
    return this.http.post(`${this.baseUrl}login`, data);
  }

  public logout() {
    this.storageService.removeToken();
    this._Router.navigate(['login']);
  }


}
